import { injectGlobal } from 'styled-components';

injectGlobal`
  html {
    background-color: #000000;
    min-height: 100%;
    min-width: 100%;
    max-width: 1281px;
  }

  body {
    position: relative;
    margin: 0;
    padding: 0;
    font-family: sans-serif;
  }

  #root {
    overflow: hidden;
  }

  .app {
    overflow: hidden;
    height: 800px;
    min-width: 700px;
    max-width: 1280px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
